import { useEffect, useState } from "react";

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    const updateMatches = (e: MediaQueryListEvent | MediaQueryList) =>
      setMatches(e.matches);

    // Prefer modern API, fallback to old one
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", updateMatches);
    } else {
      // @ts-ignore — TS doesn't know about the legacy API
      mediaQuery.addListener(updateMatches);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", updateMatches);
      } else {
        // @ts-ignore
        mediaQuery.removeListener(updateMatches);
      }
    };
  }, [query]);

  return matches;
};
